var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTipoServico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.129,
    height: 17.992,
    viewBox: "0 0 17.129 17.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-6.851 -6.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_91",
    "data-name": "Caminho 91",
    d: "M14.748,7.213,12.566,9.1,10.884,6.973a.482.482,0,0,1-.093-.194.449.449,0,0,1,.345-.573,4,4,0,0,1,3.612,1.007Z",
    fill: "#0e5573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_92",
    "data-name": "Caminho 92",
    d: "M13.944,7.85,12.566,9.1,10.884,6.973a.482.482,0,0,1-.093-.194A3.863,3.863,0,0,1,13.944,7.85Z",
    fill: "#0393ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_93",
    "data-name": "Caminho 93",
    d: "M15.641,8.316a8.767,8.767,0,0,1,.4,1.758c.345,1.194.725,2.381.758,2.473l6.223,7.8a1.651,1.651,0,0,1-.179,2.336l-.264.209a.668.668,0,0,1-.1.071,1.672,1.672,0,0,1-2.213-.412l-6.311-7.917c-5.474-1.065-5.839-3.988-5.587-5.6a3.792,3.792,0,0,1,.078-.394.461.461,0,0,1,.77-.213L11.223,10.3l3.511-3.117a2.9,2.9,0,0,1,.907,1.134Z",
    fill: "#0e5573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94",
    "data-name": "Caminho 94",
    d: "M14.924,9a8.765,8.765,0,0,1,.4,1.758c.35,1.2.73,2.387.757,2.484l6.229,7.8a1.7,1.7,0,0,1,.165,1.925,1.672,1.672,0,0,1-2.213-.412l-6.311-7.917c-5.474-1.065-5.839-3.988-5.587-5.6a.424.424,0,0,1,.137.085l2.012,1.812L13.944,7.85A3.07,3.07,0,0,1,14.924,9Z",
    fill: "#0393ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95",
    "data-name": "Caminho 95",
    d: "M18.091,16.741l3.255,4.115a.609.609,0,0,1-.07.858.5.5,0,0,1-.284.107.606.606,0,0,1-.567-.237L17.17,17.469a.606.606,0,0,1-.1-.606.5.5,0,0,1,.17-.252A.609.609,0,0,1,18.091,16.741Z",
    fill: "#ffb21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_96",
    "data-name": "Caminho 96",
    d: "M17.63,17.105l3.255,4.115a.637.637,0,0,1,.106.6.606.606,0,0,1-.567-.237L17.17,17.469a.606.606,0,0,1-.1-.606A.637.637,0,0,1,17.63,17.105Z",
    fill: "#ffc63b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_97",
    "data-name": "Caminho 97",
    d: "M14.812,19.334,10.568,23.5a1.634,1.634,0,0,1-2.254.27L7.165,22.6a1.634,1.634,0,0,1,.31-2.248l4.244-4.169a1.19,1.19,0,0,1,.935-.362l.983.125a.617.617,0,0,1,.388.176l.883.9a.69.69,0,0,1,.177.383l.106,1A1.19,1.19,0,0,1,14.812,19.334Z",
    fill: "#005665"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_98",
    "data-name": "Caminho 98",
    d: "M16.271,18.067l-.109.108a.642.642,0,0,1-.879.105l-2.5-2.545a.642.642,0,0,1,.121-.877l.109-.108a.63.63,0,0,1,.872-.1l2.5,2.545a.63.63,0,0,1-.113.87Z",
    fill: "#ffb21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_99",
    "data-name": "Caminho 99",
    d: "M14.338,18.852l-4.244,4.169a1.634,1.634,0,0,1-2.254.27L7.165,22.6a1.634,1.634,0,0,1,.31-2.248l4.244-4.169a1.19,1.19,0,0,1,.935-.362l.983.125a.617.617,0,0,1,.388.176l.409.416a.669.669,0,0,1,.177.383l.106,1a1.162,1.162,0,0,1-.378.928Z",
    fill: "#0892ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_100",
    "data-name": "Caminho 100",
    d: "M15.8,17.585l-.109.108a.635.635,0,0,1-.879.105l-2.027-2.063a.642.642,0,0,1,.121-.877l.109-.108a.63.63,0,0,1,.872-.1l2.027,2.063a.624.624,0,0,1-.113.87Z",
    fill: "#ffc63b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_101",
    "data-name": "Caminho 101",
    d: "M21.645,10.3l-5.5,5.406.246.25a.341.341,0,0,1,0,.48l-.141.138a.341.341,0,0,1-.48,0L14.5,15.284a.341.341,0,0,1,0-.48l.141-.138a.341.341,0,0,1,.48,0l.246.25,5.5-5.406-.008-.008a.434.434,0,0,1-.065-.52l.567-1a.45.45,0,0,1,.172-.169l1.012-.549a.434.434,0,0,1,.518.074l.783.8a.434.434,0,0,1,.065.52l-.574.994a.45.45,0,0,1-.172.169l-1,.557a.434.434,0,0,1-.518-.074Z",
    fill: "#b7d7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_102",
    "data-name": "Caminho 102",
    d: "M21.337,9.983l-5.5,5.406.246.25a.341.341,0,0,1,0,.48l-.141.138a.341.341,0,0,1-.48,0l-.952-.969a.341.341,0,0,1,0-.48l.141-.138a.341.341,0,0,1,.48,0l.246.25,5.5-5.406-.008-.008a.434.434,0,0,1-.065-.52l.567-1a.45.45,0,0,1,.172-.169l1.012-.549a.434.434,0,0,1,.518.074l.476.485a.434.434,0,0,1,.065.52l-.574.994a.451.451,0,0,1-.172.169l-1,.557a.434.434,0,0,1-.518-.074Z",
    fill: "#c0dded"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_159",
    "data-name": "Ret\\xE2ngulo 159",
    width: 0.665,
    height: 4.14,
    rx: 0.301,
    transform: "matrix(0.701, 0.713, -0.713, 0.701, 11.45, 17.664)",
    fill: "#085f66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_160",
    "data-name": "Ret\\xE2ngulo 160",
    width: 0.665,
    height: 4.14,
    rx: 0.301,
    transform: "matrix(0.701, 0.713, -0.713, 0.701, 12.864, 19.103)",
    fill: "#085f66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipoServico);
export default __webpack_public_path__ + "static/media/tipo-servico.5d2c81c39f2debb27a01da957883f719.svg";
export { ForwardRef as ReactComponent };